import { useLayoutEffect, useRef } from "react";
import { useBitmapPreview } from "../player/useBitmapPreview";

export function FramePreview({url, nearby, onReady}: {url: string; nearby: string[]; onReady: (url: string | null) => void}) {
  const canvas = useRef<HTMLCanvasElement>(null);
  const callback = useRef(onReady); callback.current = onReady;
  const {bitmap, failed} = useBitmapPreview(url, true, nearby);
  useLayoutEffect(() => {
    const el = canvas.current;
    if (!el) return;
    const ctx = el.getContext('2d');
    if (bitmap && ctx) {
      el.width = bitmap.width; el.height = bitmap.height;
      ctx.drawImage(bitmap, 0, 0);
      callback.current(url);
    } else {
      ctx?.clearRect(0, 0, el.width, el.height); callback.current(null);
    }
    return () => { callback.current(null); };
  }, [bitmap, url]);
  return <><canvas ref={canvas} data-frame-preview={url} data-frame-state={bitmap ? "ready" : failed ? "error" : "loading"}
    style={{position:'absolute',inset:0,width:'100%',height:'100%',pointerEvents:'none',background:bitmap ? undefined : '#05070a'}} />
    {!bitmap && <span className="frame-preview-status" role="status">{failed ? "Frame preview unavailable" : "Loading frame…"}</span>}</>;
}
